import {Injectable} from '@angular/core';

import {ClientDetailsDTO} from '@dto/entities/client-details-dto.model';
import {ClientInformationViewModel} from './client-information-view.model';
import {AddressEmptyCheckService} from '@shared/services/address-empty-check.service';

@Injectable({
  providedIn: 'root'
})
export class ClientInformationConverterService {

  private clientInformationVM: ClientInformationViewModel;
  private clientDetailsDTO: ClientDetailsDTO;
  private readonly emptyField = '(Empty)';

  public convert(clientInformationDTO: ClientDetailsDTO): ClientInformationViewModel {
    this.clientDetailsDTO = clientInformationDTO;
    this.addRequiredFields();

    switch (clientInformationDTO.baseType) {
      case 'Estate':
      case 'Other':
        break;
      case 'Trust':
      case 'Foundation':
      case 'Partnership':
        this.addRegistrationNumber();
        break;
      default:
        this.addCompanyFields();
    }

    return this.clientInformationVM;
  }

  private addRequiredFields(): void {
    this.clientInformationVM = {
      code: this.clientDetailsDTO.code || this.emptyField,
      name: this.clientDetailsDTO.name || this.emptyField,
      jurisdiction: this.clientDetailsDTO.jurisdiction || this.emptyField,
      administrativeOfficeAddressEmpty: false,
      administrativeOfficeAddress: this.clientDetailsDTO.administrativeOfficeAddress,
      administrativeOfficeAddress2: this.clientDetailsDTO.administrativeOfficeAddress2,
      administrativeOfficeCity: this.clientDetailsDTO.administrativeOfficeCity,
      administrativeOfficeCounty: this.clientDetailsDTO.administrativeOfficeCounty,
      administrativeOfficeCountry: this.clientDetailsDTO.administrativeOfficeCountry,
      administrativeOfficePostCode: this.clientDetailsDTO.administrativeOfficePostCode,
      registeredOfficeAddressEmpty: false,
      registeredOfficeAddress: this.clientDetailsDTO.registeredOfficeAddress,
      registeredOfficeAddress2: this.clientDetailsDTO.registeredOfficeAddress2,
      registeredOfficeCity: this.clientDetailsDTO.registeredOfficeCity,
      registeredOfficeCounty: this.clientDetailsDTO.registeredOfficeCounty,
      registeredOfficeCountry: this.clientDetailsDTO.registeredOfficeCountry,
      registeredOfficePostCode: this.clientDetailsDTO.registeredOfficePostCode,
    };
    this.checkRegisteredAddress();
    this.checkAdministrativeAddress();
  }

  private addRegistrationNumber(): void {
    this.clientInformationVM.registeredNumber = this.clientDetailsDTO.registeredNumber || this.emptyField;
  }

  private addCompanyFields(): void {
    this.addRegistrationNumber();
    this.clientInformationVM.countryOfIncorporation = this.clientDetailsDTO.countryOfIncorporation || this.emptyField;
    this.clientInformationVM.vatNumber = this.clientDetailsDTO.vatNumber || this.emptyField;
  }

  private checkRegisteredAddress(): void {
    const registeredAddress = [
      this.clientInformationVM.registeredOfficeAddress,
      this.clientInformationVM.registeredOfficeAddress2,
      this.clientInformationVM.registeredOfficeCity,
      this.clientInformationVM.registeredOfficeCounty,
      this.clientInformationVM.registeredOfficeCountry,
      this.clientInformationVM.registeredOfficePostCode,
    ];
    this.clientInformationVM.registeredOfficeAddressEmpty = AddressEmptyCheckService.isEmpty(registeredAddress);
  }

  private checkAdministrativeAddress(): void {
    const administrativeAddress = [
      this.clientInformationVM.administrativeOfficeAddress,
      this.clientInformationVM.administrativeOfficeAddress2,
      this.clientInformationVM.administrativeOfficeCity,
      this.clientInformationVM.administrativeOfficeCounty,
      this.clientInformationVM.administrativeOfficeCountry,
      this.clientInformationVM.administrativeOfficePostCode,
    ];
    this.clientInformationVM.administrativeOfficeAddressEmpty = AddressEmptyCheckService.isEmpty(administrativeAddress);
  }
}
